const actions = {
  async attemptLogin({}, payload) {
    try {
      console.log(payload);
      const data = await this._vm.$authApi.post("/login", payload);
      return data;
    } catch (er) {
      return er;
    }
  },

  async attemptRegister({}, payload) {
    try {
      console.log(payload);
      const data = await this._vm.$authApi.post("/register", payload);
      return data;
    } catch (er) {
      return er;
    }
  },

  async logout() {
    try {
      await this._vm.$authApi.post("/logout");
      return location.reload();
    } catch (er) {
      return er;
    }
  },

  async userValidate() {
    try {
      return await this._vm.$authApi.post("/validate");
    } catch (err) {}
  },
};
export default actions;
